/* eslint-disable @next/next/no-img-element */
import { type components, Website } from '~/fecom-api/schema';
import { cn } from '~/lib/utils';

type VendorProps = {
  roundels?: components['schemas']['Roundel'][];
  websiteId: Website;
  className?: string;
};

// Known Vendors for International Marketplace
// Clickety Books
// Dryad Big Book
// Dryad Education
// DryadBigBook
// DryadEducation
// Findel
// Kitronik
// Normans Musical Instruments
// Specialist Crafts
// Starbeck
// SureStitch
// Westcott
// Wildgoose

export function Vendor(props: VendorProps) {
  if (props.websiteId !== Website.InternationalMarketplace) {
    return null;
  }

  const vendor = props.roundels?.find((r) => r.name === 'Vendor');

  if (!vendor) {
    return null;
  }

  const getVendorImageUrl = () => {
    const basePath = '/images/vendors/';
    let vendorFilename = '';

    // vendor.text = 'kitronik';

    switch (vendor.text?.toLocaleLowerCase()) {
      case 'findel':
        vendorFilename = 'findel-logo.svg';
        break;
      case 'clickety books':
        vendorFilename = 'clickety-logo.svg';
        break;
      case 'cosy direct':
        vendorFilename = 'cosy-logo.svg';
        break;
      case 'dryad big book':
      case 'dryadbigbook':
        vendorFilename = 'dryad-big-book-logo.svg';
        break;
      case 'dryad education':
      case 'dryadeducation':
        vendorFilename = 'dryad-logo.svg';
        break;
      case 'gam':
        vendorFilename = 'gam-logo.svg';
        break;
      case 'heart':
        vendorFilename = 'heart-black-white.svg';
        break;
      case 'kitronik':
        vendorFilename = 'kitronic-logo.svg';
        break;
      case 'kidzinc':
        vendorFilename = 'kidzinc-logo.svg';
        break;
      case 'normans musical instruments':
        vendorFilename = 'normans-logo.svg';
        break;
      case 'pottery crafts':
        vendorFilename = 'potterycrafts-logo.svg';
        break;
      case 'specialist crafts':
        vendorFilename = 'specialist-crafts-logo.svg';
        break;
      case 'starbeck':
        vendorFilename = 'starbeck-logo.svg';
        break;
      case 'surestitch':
        vendorFilename = 'sure_stitch_logo.svg';
        break;
      case 'wildgoose':
        vendorFilename = 'wildgoose-logo.svg';
        break;
      default:
    }

    if (!vendorFilename) {
      return null;
    }

    const vendorImageUrl = basePath + vendorFilename;
    return vendorImageUrl;
  };

  const vendorImageUrl = getVendorImageUrl();

  if (!vendorImageUrl) {
    return null;
  }

  return (
    <img
      src={vendorImageUrl}
      alt={vendor.text ?? 'Vendor'}
      className={cn(
        'vendor',
        'pointer-events-none absolute left-px top-px block max-h-16 max-w-24 rounded-br-lg rounded-tl-[calc(var(--radius)_-_1px)] bg-white object-contain object-left-top p-1',
        props.className,
      )}
    />
  );
}
